import axios from 'axios';

const API_URL = '/patients'; // Removed /api/v1 prefix

// Function to get flowsheet data
// Note: This is a placeholder structure. The actual implementation might be more complex
// or already exist elsewhere. It's included here for completeness of flowsheet interactions.
export const getFlowsheetData = async (patientId, category, startDate, endDate) => {
  try {
    let url = `${API_URL}/${patientId}/flowsheet/data`;
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching flowsheet data:', error.response?.data?.message || error.message);
    throw error.response?.data || new Error('Failed to fetch flowsheet data');
  }
};

// Function to promote any flowsheet data to FlowsheetEntry for editing
export const promoteToFlowsheetEntry = async (patientId, entryData) => {
  try {
    const response = await axios.post(`${API_URL}/${patientId}/flowsheet/promote-entry`, entryData);
    return response.data;
  } catch (error) {
    console.error('Error promoting to flowsheet entry:', error.response?.data?.message || error.message);
    throw error.response?.data || new Error('Failed to promote to flowsheet entry');
  }
};

// Function to edit a specific flowsheet entry
export const editFlowsheetEntry = async (patientId, entryId, entryData) => {
  try {
    const response = await axios.put(`${API_URL}/${patientId}/flowsheet/entry/${entryId}`, entryData);
    return response.data;
  } catch (error) {
    console.error('Error editing flowsheet entry:', error.response?.data?.message || error.message);
    throw error.response?.data || new Error('Failed to edit flowsheet entry');
  }
};

// Function to archive (soft delete) a specific flowsheet entry
export const archiveFlowsheetEntry = async (patientId, entryId) => {
  try {
    const response = await axios.delete(`${API_URL}/${patientId}/flowsheet/entry/${entryId}`);
    return response.data;
  } catch (error) {
    console.error('Error archiving flowsheet entry:', error.response?.data?.message || error.message);
    throw error.response?.data || new Error('Failed to archive flowsheet entry');
  }
};

// Function to bulk archive (soft delete) all flowsheet entries at a specific timestamp
export const bulkArchiveFlowsheetEntriesByTimestamp = async (patientId, timestamp) => {
  try {
    const response = await axios.delete(`${API_URL}/${patientId}/flowsheet/entries/timestamp/${encodeURIComponent(timestamp)}`);
    return response.data;
  } catch (error) {
    console.error('Error bulk archiving flowsheet entries:', error.response?.data?.message || error.message);
    throw error.response?.data || new Error('Failed to bulk archive flowsheet entries');
  }
};

const flowsheetService = {
  getFlowsheetData,
  promoteToFlowsheetEntry,
  editFlowsheetEntry,
  archiveFlowsheetEntry,
  bulkArchiveFlowsheetEntriesByTimestamp,
};

export default flowsheetService;
